// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__fmczD","author":"Table_author__1nREW","authorImage":"Table_authorImage__11GqO","unreadRow":"Table_unreadRow__1FDmy"};